import { ACTION_TYPES } from '../constants/actionTypes/siteSettings';
import { statePropsForUrlSync, getUpdatedSelectedLocations } from '../../utils/siteSettingsUtils';
import { syncStateToQueryParams } from '../../utils/urlStateUtils';
import { filterSteps } from '../../appSettings';

export const defaultSiteSettings = {
  // totalHits: null,
  activeFilterStep: filterSteps[0],
  classifications: null, // object of fetched classifications
  hotelProducts: null, // object of fetched hotel products
  conceptHotels: null,
  filters: {
    selectedPrimaryClassifications: [],
    selectedSecondaryClassifications: [],
    selectedHotelProducts: [],
    selectedLocations: null,
    selectedFlightTime: null,
    selectedTemperature: null,
    selectedTemperaturePeriod: null,
    selectedPreference: null,
    selectedConceptHotels: [],
    selectedRatings: [],
    pax: {
      selectedNumberOfAdults: null,
      selectedNumberOfChildren: null,
      selectedDeparture: null,
    },
    selectedDepartureMonths: null,
  },
}

const siteSettingsReducer = (state = defaultSiteSettings, action) => {
  const reducedState = {
    ...defaultSiteSettings,
    ...state,
  }
  let newState = null;

  switch (action.type) {
    case ACTION_TYPES.SET_FILTERS: {
      return {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          ...action.payload.filters,  
        },
      }
    }
    case ACTION_TYPES.SET_ACTIVE_FILTER_STEP:
      return {
        ...reducedState,
        activeFilterStep: action.payload.step,
      }

      /**
    * State filters
    * 
    */

    case ACTION_TYPES.SET_SELECTED_PRIMARY_CLASSIFICATION: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedPrimaryClassifications: action.payload.selectedClassifications,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_SECONDARY_CLASSIFICATION: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedSecondaryClassifications: action.payload.selectedClassifications,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_HOTEL_PRODUCT: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedHotelProducts: action.payload.selectedHotelProducts,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_CONCEPT_HOTEL: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedConceptHotels: action.payload.selectedConceptHotels,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_RATING: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedRatings: action.payload.selectedRatings,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_PREFERENCE: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedLocations: null,
          selectedFlightTime: null,
          selectedTemperature: null,
          selectedTemperaturePeriod: null,
          selectedPreference: action.payload.preference,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_LOCATION: {
      const clickedLocation = action.payload.location;
      const { selectedLocations } = reducedState.filters;
      const updatedSelectedLocations = getUpdatedSelectedLocations(clickedLocation, selectedLocations);

      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedFlightTime: null,
          selectedTemperature: null,
          selectedTemperaturePeriod: null,
          selectedLocations: updatedSelectedLocations,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_FLIGHT_TIME: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedLocations: null,
          selectedTemperature: null,
          selectedTemperaturePeriod: null,
          selectedFlightTime: action.payload.flightTime,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_TEMPERATURE_PERIOD: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedLocations: null,
          selectedFlightTime: null,
          selectedTemperaturePeriod: action.payload.temperaturePeriod,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_TEMPERATURE: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          selectedLocations: null,
          selectedFlightTime: null,
          selectedTemperature: action.payload.temperature,
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_NUMBER_OF_ADULTS: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          pax: {
            ...reducedState.filters.pax,
            selectedNumberOfAdults: action.payload.numberOfAdults,
          },
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_NUMBER_OF_CHILDREN: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          pax: {
            ...reducedState.filters.pax,
            selectedNumberOfChildren: action.payload.numberOfChildren,
          },
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_DEPARTURE: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          pax: {
            ...reducedState.filters.pax,
            selectedDeparture: action.payload.selectedDeparture,
            selectedDepartureCaIdDict: action.payload.selectedDepartureCaIdDict,
          },
        },
      }
      break;
    }
    case ACTION_TYPES.SET_SELECTED_DEPARTURE_MONTHS: {
      newState = {
        ...reducedState,
        filters: {
          ...reducedState.filters,
          pax: {
            ...reducedState.filters.pax,
          },
          selectedDepartureMonths: action.payload.selectedDepartureMonths,
        },
      }
      break;
    }

    /**
     * END State filters
     */

    default:
      return { ...reducedState }
  }

  /*
    If an action was called that updates a filter setting,
    we do a break and assign the updated state to the variable newState
    Before returning it we do a url-queryParams sync of that state.
  */
  syncStateToQueryParams(
    statePropsForUrlSync(
      newState.filters,
      newState.classifications,
      newState.hotelProducts,
      newState.conceptHotels,
      ))
  return newState;
};

export default siteSettingsReducer;
